import axios from 'axios';
import Environments from '../environments/Environment';

var http = null;

class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL2,
            headers: { 'Content-Type': 'application/json' },
        });
    }

    generateInsurance(data) {
        return new Promise((success, error) => {
            http.post('/landing/insurances/generateInsurance', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                console.log(err);
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
                // console.log(error.config);
            });
        });
    }

    saveQuotation(data) {
        return new Promise((success, error) => {
            http.post('/landing/insurances/saveQuotation', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    newInsurance(data) {
        return new Promise((success, error) => {
            http.post('/landing/insurances', data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    createUser(data) {
        return new Promise((success, error) => {
            http.post(`/payments/create/user`, data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

    payInsurance(data, id) {
        return new Promise((success, error) => {
            http.post(`/landing/insurances/pay/${id}`, data).then((result) => {
                if (result.data.response)
                    success(result.data);
                else
                    error(result.data);
            }).catch(function(err) {
                if (err.response) {
                    error(err.response.data);
                } else if (err.request) {
                    error(err.request);
                } else {
                    error(err.message);
                }
            });
            // console.log(error.config);
        });
    }

}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/Policy.js